module.exports = __webpack_public_path__ + "media/images/photos/8-0416dbda8e9ae067be2cbf56becf5f03.jpg";